module.exports = function (app) {
    app.directive('claimsRefine', function () {
        return {
            template: require('directives/claims/claimsRefine.html'),
            restrict: 'A',
            controller: ['$scope','$filter', function ($scope,$filter) {
                $scope.refine={};
                $scope.refine.claimStatus = [
                    { label: 'Approved', checked: false, show: true, code: '1', count: 0 },
                    { label: 'Partially Approved', checked: false, show: true, code: '2', count: 0 },
                    { label: 'Denied', checked: false, show: true, code: '3', count: 0 },
                    { label: 'Adjusted', checked: false, show: true, code: '4', count: 0 },
                    { label: 'In Process', checked: false, show: true, code: '5', count: 0 }
                ];

                $scope.refine.claimTypes = [
                    { label: 'Medical', checked: false, show: true, count: 0 },
                    { label: 'Drug', checked: false, show: true, count: 0 },
                    { label: 'Dental', checked: false, show: true, count: 0 }
                ];

                $scope.refine.dateRangeOptions = [
                    {
                        label: "Last 12 Months",
                        value: JSON.stringify({
                            startDate: $filter('date')(new Date() - 365 * 60 * 60 * 24 * 1000, 'yyyyMMdd'),
                            endDate: $filter('date')(new Date(), 'yyyyMMdd')
                        })
                    },
                    {
                        label: "Last 6 Months",
                        value: JSON.stringify({
                            startDate: $filter('date')(new Date() - 180 * 60 * 60 * 24 * 1000, 'yyyyMMdd'),
                            endDate: $filter('date')(new Date(), 'yyyyMMdd')
                        })
                    },
                    {
                        label: "Last 90 Days",
                        value: JSON.stringify({
                            startDate: $filter('date')(new Date() - 90 * 60 * 60 * 24 * 1000, 'yyyyMMdd'),
                            endDate: $filter('date')(new Date(), 'yyyyMMdd')
                        })
                    },
                    {
                        label: "Last 60 Days",
                        value: JSON.stringify({
                            startDate: $filter('date')(new Date() - 60 * 60 * 60 * 24 * 1000, 'yyyyMMdd'),
                            endDate: $filter('date')(new Date(), 'yyyyMMdd')
                        })
                    },
                    {
                        label: "Last 30 Days",
                        value: JSON.stringify({
                            startDate: $filter('date')(new Date() - 30 * 60 * 60 * 24 * 1000, 'yyyyMMdd'),
                            endDate: $filter('date')(new Date(), 'yyyyMMdd')
                        })
                    }
                ];
            }
            ]
        };
    });
};
